import { Controller } from 'stimulus';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

class SliderController extends Controller {
  connect() {
    this.swiper = new Swiper(this.sliderTarget, {
      ...this.sliderOptionsFromElement(),

      modules: [Navigation, Pagination],

      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },

      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : null,
        type: 'bullets',
      },

      scrollbar: {
        el: this.hasScrollbarTarget ? this.scrollbarTarget : null,
      },
    });

    this.setNavigationArrows(true);

    this.swiper.on('slideChange', this.setNavigationArrows.bind(this));
  }

  setNavigationArrows(onInit = false) {
    if (!this.hasNavigationTarget) return;

    const currentSlide = this.swiper.slides[this.swiper.activeIndex];
    const content = currentSlide.querySelector('[data-target="slider.content"]');
    const contentHeight = content.offsetTop + content.offsetHeight;

    this.navigationTarget.style.top = `${contentHeight}px`;

    setTimeout(() => {
      this.navigationTarget.style.opacity = 1;
    }, onInit ? 300 : 0);
  }

  sliderOptionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = /^slider/g;

      if (!regex.test(option)) {
        return;
      }

      let value = options[option];
      let transformedOption = option.replace('slider', '');

      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[transformedOption] = transformedOption === 'breakpoints'
        ? JSON.parse(value)
        : value;
    });

    return config;
  }
}

SliderController.targets = [
  'prev',
  'next',
  'slider',
  'scrollbar',
  'pagination',
  'navigation',
];

export default SliderController;
